import type { PropsWithChildren, ReactNode } from "react";

type TypoListProps = PropsWithChildren<{
  readonly ordered?: boolean;
}>;

export function TypoList({
  children,
  ordered = false,
}: TypoListProps): ReactNode {
  return ordered ? (
    <ol className="ml-4 list-decimal pl-0.5">{children}</ol>
  ) : (
    <ul className="ml-4 list-disc pl-0.5">{children}</ul>
  );
}
